import { Gpt } from '@pcln/ad-unit'
import { Divider as HorizonDivider, Heading, P } from '@pcln/horizon'
import { SearchFormCard } from '@pcln/horizon-search-form'
import { themeGet } from '@styled-system/theme-get'
import { Box, Card, Container, Divider, Flex, Hide, Text } from 'pcln-design-system'
import styled from 'styled-components'

import ComponentMetricsBoundary from '@/components/ComponentMetricsBoundary/ComponentMetricsBoundary'

import ConditionalRender, { Experiment, Original } from '../../ConditionalRender'
import HeroImageParallax from '../../Heros/HeroImageParallax'
import Content from '../Content'
import HorizonPackagesForm from '../HorizonForm/HorizonPackagesForm'
import PackagesSearchForm from '../SearchForm/Form'
import GenericErrorBanner from '../SearchForm/GenericErrorBanner'
import { onSubmit } from '../SearchForm/utils'
import usePackagesLandingFormContent from '../usePackagesLandingFormContent'

const BlockFlex = styled(Box)`
  position: relative;
  z-index: 1;
  ${themeGet('mediaQueries.xxl')} {
    display: flex;
  }
`

const HideAdUnit = styled(Hide)`
  flex: none;
  text-align: center;
  position: relative;
  margin: 16px;
  min-height: 90px;
  ${themeGet('mediaQueries.xxl')} {
    width: 300px;
    margin: 0 16px 0 16px;
  }
`

const footerText = 'Save up to $625 when you book your hotel and flight together!'

function HorizonPackagesLandingForm() {
  const { getHeadline, shouldShowErrorBanner } = usePackagesLandingFormContent('landing')

  return (
    <SearchFormCard variant='panel' width='full'>
      <Heading
        as='h1'
        palette='primary'
        shade='12'
        textStyle='heading3'
        className='m-0 pb-1 text-heading3 lg:text-heading2'
      >
        {getHeadline()}
      </Heading>
      {shouldShowErrorBanner && (
        <div className='mb-3'>
          <GenericErrorBanner />
        </div>
      )}
      <HorizonPackagesForm onSubmit={onSubmit} pageName='landing' />
      <div
        className='-mx-4 mt-4 -mb-4 overflow-hidden rounded-b-lg bg-neutral-1'
        data-testid='horizon-packages-footer'
      >
        <HorizonDivider lineSlotBeforeClassName='my-0' />
        <div className='flex justify-center bg-neutral-1 p-4'>
          <P textStyle='body2' palette='neutral' shade='12' align='center' className='m-0'>
            {footerText}
          </P>
        </div>
      </div>
    </SearchFormCard>
  )
}

function Desktop() {
  return (
    <Box data-testid='packages-desktop'>
      <HeroImageParallax
        isScrollable
        gptId='div-gpt-ad-1511925223449-0'
        slot='/3102/priceline.dart/vp_homepage_hero_image'
        data-testid='pcln-hero-image-parallax'
        mb={4}
      >
        <Container maxWidth={1280}>
          <BlockFlex mx={3} py={[3, null, null, null, 5]} pb={3}>
            <ComponentMetricsBoundary componentId='SearchFormPackages'>
              <ConditionalRender experimentCode='USB_SEARCH_PCKG_LANDING_HORIZON'>
                <Original>
                  <Card
                    borderWidth={0}
                    color='background.lightest'
                    borderRadius='2xl'
                    boxShadowSize='xl'
                    width={1}
                  >
                    <Box p={3}>
                      <PackagesSearchForm onSubmit={onSubmit} pageName='landing' />
                    </Box>
                    <Divider my={0} borderColor='border.base' />
                    <Flex
                      p={3}
                      borderRadius='2xl'
                      boxShadowSize='xl'
                      rounded='bottom'
                      color='background.light'
                      justifyContent='center'
                    >
                      <Text fontSize={1} textAlign='center' color='text.dark'>
                        {footerText}
                      </Text>
                    </Flex>
                  </Card>
                </Original>
                <Experiment>
                  <HorizonPackagesLandingForm />
                </Experiment>
              </ConditionalRender>
            </ComponentMetricsBoundary>

            <HideAdUnit xs sm>
              <Gpt render={() => <div id='div-gpt-ad-1511925695047-0' />} />
            </HideAdUnit>
          </BlockFlex>
        </Container>
      </HeroImageParallax>
      <Hide xs sm color='background.lightest'>
        <Content />
      </Hide>
    </Box>
  )
}

export default Desktop
